import * as React from "react";
import { SearchResult } from "@repo/convex/convex/search.ts";
import { ItemThumbnail, SiteIcon } from "../common/items/ItemPictures.tsx";
import { domain, itemTitle, videoLength } from "../common/items/format.ts";
import { itemKind } from "../common/items/itemKind.ts";

interface Props {
  item: SearchResult["item"];
  selected?: boolean;
  onHover?: () => void;
  onOpen: () => void;
}

const statusLabels = {
  unread: "In the stash",
  archived: "Archived",
  trashed: "In the trash",
} as const;

/** One result: its picture, title, site, and which list it's in. */
export const SearchItem: React.FC<Props> = ({ item, selected, onHover, onOpen }) => {
  const ref = React.useRef<HTMLButtonElement>(null);
  const length = itemKind(item.url).kind == "video" ? videoLength(item.videoSeconds) : null;

  React.useEffect(() => {
    if (selected) ref.current?.scrollIntoView({ block: "nearest" });
  }, [selected]);

  return (
    <button
      ref={ref}
      type="button"
      role="option"
      aria-selected={selected}
      className="search-item"
      onMouseMove={onHover}
      onClick={onOpen}
    >
      <ItemThumbnail item={item} size={44} />
      <span className="search-item-text">
        <span className="search-item-title">{itemTitle(item)}</span>
        <span className="search-item-meta">
          <SiteIcon item={item} size={13} />
          <span className="search-item-domain">{domain(item.url)}</span>
          {length && (
            <>
              <span aria-hidden>·</span>
              <span>{length}</span>
            </>
          )}
          <span aria-hidden>·</span>
          <span>{statusLabels[item.status.kind]}</span>
        </span>
      </span>
    </button>
  );
};
